import { gql, TypedDocumentNode } from "@apollo/client";

import { LogsDownloadUrl } from "types/generated";

type LogsDownloadUrlEntity = {
  id: string;
  run?: {
    id: string;
    logsDownloadURL?: Pick<LogsDownloadUrl, "url" | "deleted" | "expired" | "ongoing"> | null;
  } | null;
};

type StackLogsDownloadUrlData = { stack: LogsDownloadUrlEntity | null };

type ModuleLogsDownloadUrlData = { module: LogsDownloadUrlEntity | null };

export type LogsDownloadUrlData = StackLogsDownloadUrlData | ModuleLogsDownloadUrlData;

export const GET_STACK_LOGS_DOWNLOAD_URL: TypedDocumentNode<StackLogsDownloadUrlData> = gql`
  query GetStackLogsDownloadURL($stackId: ID!, $runId: ID!, $state: RunState!, $stateVersion: Int) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        logsDownloadURL(state: $state, stateVersion: $stateVersion) {
          url
          deleted
          expired
          ongoing
        }
      }
    }
  }
`;

export const GET_MODULE_LOGS_DOWNLOAD_URL: TypedDocumentNode<ModuleLogsDownloadUrlData> = gql`
  query GetModuleLogsDownloadURL($moduleId: ID!, $runId: ID!, $state: RunState!) {
    module(id: $moduleId) {
      id
      run(id: $runId) {
        id
        logsDownloadURL(state: $state) {
          url
          deleted
          expired
          ongoing
        }
      }
    }
  }
`;

export const GET_STACK_LOGS_SANITIZED = gql`
  query GetStackLogsSanitized(
    $stackId: ID!
    $runId: ID!
    $state: RunState!
    $token: String
    $stateVersion: Int
  ) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        logs(state: $state, token: $token, stateVersion: $stateVersion, sanitize: true) {
          exists
          deleted
          expired
          finished
          hasMore
          ongoing
          messages {
            message
          }
          nextToken
        }
      }
    }
  }
`;

export const GET_MODULE_LOGS_SANITIZED = gql`
  query GetModuleLogsSanitized($moduleId: ID!, $runId: ID!, $state: RunState!, $token: String) {
    module(id: $moduleId) {
      id
      run(id: $runId) {
        id
        logs(state: $state, token: $token, sanitize: true) {
          exists
          deleted
          expired
          finished
          hasMore
          ongoing
          messages {
            message
          }
          nextToken
        }
      }
    }
  }
`;
